import _ from 'lodash';

export default function identifyIsDocumentationOnlyBMP(passedBMP){
	let bmp = _.cloneDeep(passedBMP);

	let toReturn = true;
	if (!_.isEmpty(bmp.cas) /*&& bmp.status != "Documentation"*/) toReturn = false;

	return toReturn;
}